jQuery(document).ready(function($) {

    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $('.top').fadeIn();
        } else {
            $('.top').fadeOut();
        }
    });

    
    
    $('.top').click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });

    $('[href^="#catalog"]').on('click', function(){
        let href = $(this).attr('href'), elem = $(document).find(href);
        if(elem.length > 0) {
          let posY = elem.eq(0).offset().top;
          $('html, body').animate({
            scrollTop: posY
          }, 500);
        }
        return false;
    });

    $('input[type="tel"]').mask("+7(999)999-99-99");

    $('button[data-modal="order"]').click(function() {
		$('.popup-fade').fadeIn();
		return false;
	});

    closePopup('.popup-fade', '.popup', '.popup-close');


    $('.wpcf7').on('wpcf7mailsent', function(e) {
        $('.overlay, .overlay_stop, .popup-fade').fadeOut();
        $('#thanks').fadeIn();
      });

    closePopup('.overlay_thanks', '.thanks', '.thanks__close');

});


      
function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

jQuery(document).mouseleave(function(e){
    var alertwin = getCookie("alertwin");
    if(alertwin != "no") {
        if (e.clientY < 0) {
            jQuery(".popup-fade").fadeIn("fast");    
            var date = new Date;
            date.setDate(date.getDate() + 1);    
            document.cookie = "alertwin=no; path=/; expires=" + date.toUTCString();       
        } 
    }
});

function closePopup(overlay, popup, close) { 

    jQuery(close).on('click', function () {
        jQuery(overlay).fadeOut(500);
        jQuery('.wpcf7-response-output').fadeOut();
    });       

    jQuery(document).keydown(function(e) {
        if (e.keyCode === 27) {
            e.stopPropagation();
            jQuery(overlay).fadeOut();
        }
    });

    jQuery(overlay).click(function(e) {
        if (jQuery(e.target).closest(popup).length == 0) {
            jQuery(this).fadeOut();					
        }
    });     

    return false;

};